import { VersionInfoDto } from './version-info.dto';

export class ApplicationVersionDto {
    frontend: VersionInfoDto;
    backend: VersionInfoDto;

    constructor(src: Partial<ApplicationVersionDto>) {
        this.frontend = new VersionInfoDto(src.frontend || {});
        this.backend = new VersionInfoDto(src.backend || {});
    }
}
